import React, {useEffect, useState} from 'react';
import {Button} from 'react-bootstrap';

let CheckAllButton = (props) => {
  const [title, setTitle] = useState(gettext('Выделить все'));
  const [checkAll, setCheckAll] = useState(false);

  useEffect(() => {
    makeChecked(props.checked)
  }, [props.checked]);

  const makeChecked = (checked) => {
    if (checked){
      setCheckAll(true);
      setTitle(gettext('Снять выделение'));
    } else {
      setCheckAll(false);
      setTitle(gettext('Выделить все'));
    }
  };

  const handleCheckAllClick = () => {
    makeChecked(!checkAll);
    props.onCheckAllClick(!checkAll);
  };

  return <Button variant="primary" size="sm" title={title} disabled={props.disabled} onClick={handleCheckAllClick}>
    <span className="icon icon-ok-circled2"></span> {title}
  </Button>
};
export default CheckAllButton;